import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=7fca3e2f&scoped=true&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"
import style0 from "./Sample.vue?vue&type=style&index=0&id=7fca3e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca3e2f",
  null
  
)

export default component.exports